<template>
    <div class="batch-h5">
        <!-- 搜索条件 -->
        <div class="search-box">
            <div class="filter-row" style="display: flex; align-items: center; margin-bottom: 12px; flex-wrap: nowrap;">
                <select v-model="searchParams.isSucessPick" style="width: 70px; height: 30px; border: 1px solid #ddd; border-radius: 4px; padding: 0 4px; font-size: 12px; background: white; margin-right: 4px;">
                    <option value="">全部</option>
                    <option :value="true">是</option>
                    <option :value="false">否</option>
                </select>
                <span style="font-size: 12px; color: #333; white-space: nowrap; margin-right: 12px;">完成拣货</span>

                <select v-model="searchParams.isAllocate" style="width: 70px; height: 30px; border: 1px solid #ddd; border-radius: 4px; padding: 0 4px; font-size: 12px; background: white; margin-right: 4px;">
                    <option value="">全部</option>
                    <option :value="true">是</option>
                    <option :value="false">否</option>
                </select>
                <span style="font-size: 12px; color: #333; white-space: nowrap;">归属自己</span>
            </div>

            <div class="search-row">
                <input type="text"
                       v-model="searchParams.batchNumber"
                       placeholder="请输入批次号"
                       class="search-input" />
                <button @click="handleSearch" class="search-btn">搜索</button>
            </div>
        </div>

        <!-- 批次列表 -->
        <div class="batch-list">
            <div v-for="item in list" :key="item.id" class="batch-item" @click="goToPickDetail(item)">
                <div class="item-header">
                    <span class="batch-number">{{ item.batchNumber }}</span>
                    <span style="font-size: 14px; color: #ff4444; font-weight: 500;">{{ item.allocateName || '未分配' }}</span>
                    <span class="pack-status" :class="{ 'packed': item.isSucessPick }">
                        {{ item.isSucessPick ? '已完成' : '未完成' }}
                    </span>
                </div>

                <div class="item-stats">
                    <div class="stat-item">
                        <span class="stat-label">订单数量</span>
                        <span class="stat-value">{{ item.count || 0 }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">SKU数量</span>
                        <span class="stat-value">{{ item.skuCount || 0 }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">产品总数</span>
                        <span class="stat-value">{{ item.productCount || 0 }}</span>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="list.length === 0" class="empty-state">
                暂无数据
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'BackStockBatchH5',
  data() {
    return {
      searchParams: {
        isSucessPick: false, // 默认未完成打包
        isPick: true,        // 默认搜索isPick为true
        batchNumber: '',
            isAllocate: true,
            isPacked:false,
      }
    };
  },
  computed: {
    ...mapState('backStockOrderBatch', ['list', 'loading'])
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions('backStockOrderBatch', ['getStockOrderBatchListForH5']),

    async loadData() {
      const params = {
        isSucessPick: this.searchParams.isSucessPick,
        isPick: this.searchParams.isPick,
          batchNumber: this.searchParams.batchNumber || undefined,
          isAllocate: this.searchParams.isAllocate === '' ? undefined : this.searchParams.isAllocate,
      };

      await this.getStockOrderBatchListForH5({
        data: params
      });
      },

      goToPickDetail(item) {
          //this.$router.push({
          //    name: 'BackStockPickH5',
          //    query: {
          //        id: item.id,
          //        batchNumber: item.batchNumber,
          //        isBatchCompleted: item.isSucessPick,

          //    },
          //});

          this.$router.push({
              name: 'BackStockPickNewH5',
              query: {
                  id: item.id,
                  batchNumber: item.batchNumber,
                  isBatchCompleted: item.isSucessPick,

              },
          });
      },

    handleSearch() {
      this.loadData();
    }
  }
};
</script>

<style scoped>
    .batch-h5 {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding: 12px;
    }

    .search-box {
        background: white;
        border-radius: 8px;
        padding: 12px;
        margin-bottom: 12px;
    }

    .filter-row {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    .filter-select {
        width: 100px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 14px;
        background: white;
        margin-right: 8px;
    }

    .filter-label {
        font-size: 14px;
        color: #333;
    }

    .search-row {
        display: flex;
        gap: 8px;
    }

    .search-input {
        flex: 1;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 12px;
        font-size: 14px;
    }

    .search-btn {
        width: 70px;
        height: 40px;
        background-color: #007aff;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
    }

        .search-btn:active {
            opacity: 0.8;
        }

    .batch-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .batch-item {
        background: white;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }

    .batch-number {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }

    .pack-status {
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        background-color: #ff9800;
        color: white;
    }

        .pack-status.packed {
            background-color: #4caf50;
        }

    .item-stats {
        display: flex;
        justify-content: space-around;
        text-align: center;
    }

    .stat-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .stat-label {
        font-size: 12px;
        color: #666;
    }

    .stat-value {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }

    .empty-state {
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
    }
</style>